<template>
  <div>
    <div class="container">
      <el-col :span="14">
        <div class="web_tilte">
          <h2>展会资讯</h2>
        </div>
      </el-col>
      <el-col :span="10">
        <div class="search">
          <el-col :span="10" :offset=10>
            <el-input v-model="formData.keyword" placeholder="请输入关键字"></el-input>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="searchExhibition()">搜索</el-button>
          </el-col>
        </div>
      </el-col>
      <hr class="string" />
      <div class="expo">
        <el-row :gutter="24">
          <el-col :span="20" v-for="(item,index) in tableData" :key="index">
            <el-card v-if="!!item.link" shadow="hover" class="expo_b">
              <div class="article_img">
                <a :href="item.link"><img :src="item.img" alt width="400" height="370px" /></a>
              </div>
              <router-link
                tag="a"
                :to="{
                            name:'ExhibitionContent',
                            query: {   
                                id: item.id, // orderNum : this.searchData.orderNo   
                            }
                        }"
              >
                <p class="article_title">{{item.title}}</p>
                <p class="article_author">{{item.author}}</p>
                <p class="article-date">{{item.date}}</p>
                <p class="article">{{item.content}}</p>
              </router-link>
            </el-card>
            <el-card v-else shadow="hover" class="expo_b">
              <router-link
                tag="a"
                :to="{
                            name:'ExhibitionContent',
                            query: {   
                                id: item.id, // orderNum : this.searchData.orderNo   
                            }
                        }"
              >
              <div class="article_img">
                <img :src="item.img" alt width="400" height="370px" />
              </div>
              
                <p class="article_title">{{item.title}}</p>
                <p class="article_author">{{item.author}}</p>
                <p class="article-date">{{item.date}}</p>
                <p class="article">{{item.content}}</p>
              </router-link>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <el-pagination
        class="pagination pagebar"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formData.page"
        :page-sizes="[20,60,100,140]"
        :page-size="formData.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="count"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "Exhibition",
  data() {
    return {
      formData: {
        keyword: "",
        startDate: "",
        endDate: "",
        page: 1,
        limit: 20
      },
      count: 0,
      tableData: [],
      noLink:"#"
    };
  },
  methods: {
    SearchExhibition() {
      let formData = this.formData;
      this.$http
        .post("/v2/SearchExhibition", { formData })
        .then(res => {
          console.log("asda",res.data);
          this.tableData = res.data;

          this.count = res.count;
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSizeChange(val) {
      this.formData.limit = val;
      this.SearchExhibition();
    },
    handleCurrentChange(val) {
      this.formData.page = val;
      this.SearchExhibition();
    }
  },
  created() {
    this.SearchExhibition();
  },
  mounted() {}
};
</script>

<style scoped>
.container {
  padding-top: 50px;
  padding-bottom: 50px;
}
.expo {
  margin: 5%;
}
.expo_b {
  margin-top: 2%;
  margin-bottom: 2%;
}

.web_tilte {
  padding: 2%;
}
.string {
  margin-top: 6%;
  margin-bottom: 2%;
}
.article_img {
  position: relative;
  width: 870px;
  margin: 0px 0px 29px;
}
.article_img img {
  width: 870px;
}
.article {
  width: 100%;
  font-size: 16px;
  color: #5e5e5e;
  font-family: initial;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.article_title {
  text-align: left;
  font-size: 20px;
  color: #000000;
  font-family: "Abel", Helvetica, Arial, Lucida, sans-serif !important;
  padding: 1% 0;
}

.article_author {
  font-size: 10px;
  color: #666;
  height: 20px;
  line-height: 20px;
  overflow: hidden;
}
.article-date {
  font-size: 16px;
  color: #5e5e5e;
  padding: 1% 0;
}
.pagebar {
  margin-top: 3%;
  clear: both;
}
</style>